import { apiGet } from "./api_methods";
import { RECRUITER_INVITATIONS_BASE } from "./endpoints";

/**
 * Get all recruiter invitations (combined: interviews, job posts, mock tests, resume sortings).
 * GET /api/v1/recruiter/invitations
 * @param {Object} params - { clientId?, isDeleted?, skip?, limit?, searchFilter? }
 * @returns {Promise<{ body, status }>} body: { success, count, data, completedApplicants }
 */
export async function getRecruiterInvitations(params = {}) {
  const q = {};
  if (params.clientId != null) q.clientId = params.clientId;
  if (params.isDeleted != null) q.isDeleted = params.isDeleted;
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;
  if (params.searchFilter != null && params.searchFilter !== "")
    q.searchFilter = params.searchFilter;
  const query = new URLSearchParams(q).toString();
  const path = query
    ? `${RECRUITER_INVITATIONS_BASE}?${query}`
    : RECRUITER_INVITATIONS_BASE;
  return apiGet(path);
}

/**
 * Fetches a paginated list of standalone "Company Interview Invitations"
 * GET /api/v1/recruiter/invitations/company-interview-invitations
 * @param {Object} params - { skip, limit, clientId, searchFilter, isDeleted }
 */
export async function getCompanyInterviewInvitations(params = {}) {
  const q = {};
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;
  if (params.clientId != null && params.clientId !== "")
    q.clientId = params.clientId;
  if (params.searchFilter != null && params.searchFilter !== "")
    q.searchFilter = params.searchFilter;
  if (params.isDeleted != null) q.isDeleted = params.isDeleted;

  const query = new URLSearchParams(q).toString();
  const path = query
    ? `${RECRUITER_INVITATIONS_BASE}/company-interview-invitations?${query}`
    : `${RECRUITER_INVITATIONS_BASE}/company-interview-invitations`;
  return apiGet(path);
}

/**
 * Fetches a paginated list of standalone "Mock Test Invitations"
 * GET /api/v1/recruiter/invitations/mock-test-invitations
 * @param {Object} params - { skip, limit, clientId, searchFilter, isDeleted }
 */
export async function getMockTestInvitations(params = {}) {
  const q = {};
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;
  if (params.clientId != null && params.clientId !== "")
    q.clientId = params.clientId;
  if (params.searchFilter != null && params.searchFilter !== "")
    q.searchFilter = params.searchFilter;
  if (params.isDeleted != null) q.isDeleted = params.isDeleted;

  const query = new URLSearchParams(q).toString();
  const path = query
    ? `${RECRUITER_INVITATIONS_BASE}/mock-test-invitations?${query}`
    : `${RECRUITER_INVITATIONS_BASE}/mock-test-invitations`;
  return apiGet(path);
}
